<template>
  <div class="dicom-control flex row align-items-center" :style="cssStyle">
    <el-slider class="slider" v-model="currenScale" @change="$emit('zoom-to', $event)"
               vertical :min=".1" :max="maxImageScale" height="180px" :show-tooltip="false">
    </el-slider>
    <div>
      <p class="zoom-value">
        {{ scale }}
      </p>
      <main class="control" @click="zoomTo">
        <a v-show="imageScale===40" class="control-btn" data-index="40"/>
        <a class="control-btn" data-index="20"/>
        <a class="control-btn" data-index="10"/>
        <a class="control-btn" data-index="4"/>
        <a class="control-btn" data-index="2"/>
        <a class="control-btn" data-index="1"/>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HzztControl',
  props: {
    scale: Number,
    imageScale: {
      type: Number,
      default: 10,
    },
    cssStyle: {
      type: Object,
      default: () => ({
        left: '10px',
        top: '20px',
      }),
    },
  },
  data() {
    return {
      zoom: 0.5,
      currenScale: 0,
    };
  },
  computed: {
    maxImageScale() {
      return this.imageScale * 2;
    },
  },
  watch: {
    scale(val) {
      this.currenScale = val;
    },
  },
  created() {
    this.currenScale = this.scale;
  },
  methods: {
    zoomTo(event) {
      const target = event.target;
      if (target.classList.contains('control-btn')) {
        this.$emit('zoom-to', target.getAttribute('data-index'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dicom-control {
  position: absolute;
  padding: 10px 0;
  z-index: 99;

  .zoom-value {
    font-size: 12px;
    width: 64px;
    height: 25px;
    margin: 0 auto;
    border-radius: 2px;
    color: #000;
    font-weight: bold;
    text-align: center;
    line-height: 25px;
    background-image: url(@/assets/img/kfb-view/zoom.png);
    background-size: 64px 25px;
  }

  .control {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .control-btn {
    width: 64px;
    height: 25px;
    cursor: pointer;
    background-size: 64px 25px;
    margin: 10px 0 0;

    &:nth-child(6) {
      background-image: url(@/assets/img/kfb-view/home.png);
    }

    &:nth-child(5) {
      background-image: url(@/assets/img/kfb-view/2.png);
    }

    &:nth-child(4) {
      background-image: url(@/assets/img/kfb-view/4.png);
    }

    &:nth-child(3) {
      background-image: url(@/assets/img/kfb-view/10.png);
    }

    &:nth-child(2) {
      background-image: url(@/assets/img/kfb-view/20.png);
    }

    &:nth-child(1) {
      background-image: url(@/assets/img/kfb-view/40.png);
    }
  }

  .zoom-operate {
    display: flex;
    background-color: #faf7f5;
    opacity: 0.8;
  }
  .slider /deep/ .el-slider__button {
    border: #4868b9 2px solid;
  }
  .slider /deep/ .el-slider__bar {
    background-color: #4868b9;
  }
}
</style>